/* src/app/private/components/user/user-profile/user-profile.component.scss */
label {
  margin-bottom: 5px;
}
.bordered-card {
  border: 1px solid var(--secondry-light-gray);
  border-radius: 10px;
}
.no-shadow-select {
  box-shadow: var(--p-select-shadow) !important;
}
.no-shadow-input {
  box-shadow: var(--p-inputtext-shadow) !important;
}
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.loading-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border-radius: 12px;
}
/*# sourceMappingURL=user-profile.component.css.map */
